import { render, staticRenderFns } from "./AttendancePostCreateDialog.vue?vue&type=template&id=0bd33060&scoped=true"
import script from "./AttendancePostCreateDialog.vue?vue&type=script&lang=js"
export * from "./AttendancePostCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd33060",
  null
  
)

export default component.exports